import { useEffect } from "react";
import { TimeSpan } from '../../utils';

type MouseLeaveSettings = { delay: TimeSpan, timeout?: any };
export function useMouseLeave(ref: any,
    onLeave: (e: MouseEvent) => void,
    settings: MouseLeaveSettings = { delay: TimeSpan.fromMilliseconds(500) }) {

    useEffect(() => {
        if (!ref) return;
        function handleMouseLeave(event: MouseEvent) {
            clearTimeout(settings.timeout);
            settings.timeout = setTimeout(() => {
                onLeave(event);
            }, settings.delay.milliseconds);
        }

        function handleMouseEnter() {
            clearTimeout(settings.timeout);
        }
        ref.addEventListener('mouseleave', handleMouseLeave);
        ref.addEventListener('mouseenter', handleMouseEnter);
        return () => {
            ref.removeEventListener('mouseenter', handleMouseLeave);
            ref.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [ref]);
}
